import React from 'react';
interface EyebrowLabelProps {
  children: React.ReactNode;
  className?: string;
}
export function EyebrowLabel({
  children,
  className = ''
}: EyebrowLabelProps) {
  return <div className={`font-sans font-bold text-xs md:text-sm tracking-widest uppercase text-blue-deep ${className}`} data-id="element-45">
      {children}
    </div>;
}